<template>
    <div>
        <template v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </template>
        <template v-else>
            <vue-headful :title="'Edit Corrective Action :: MeritEHS'"/>

            <corrective-action-breadcrumbs :action="action" mode="Edit"></corrective-action-breadcrumbs>

            <div class="row">
                <div class="col-xl-8 col-lg-12">
                    <b-card class="mb-4">
                        <div slot="header">Details</div>

                        <div class="form-group row">
                            <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.status_id}">Status:</label>
                            <div class="col-sm-8">

                                <b-form-select v-model="action.status_id" :options="statuses" style="width: 100%"></b-form-select>

                                <span v-if="errors.status_id" class="text-danger">
                                    <span v-for="error in errors.status_id">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row" v-if="Object.keys(sources).length > 0">
                            <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.corrective_source_id}">Source:</label>
                            <div class="col-sm-8">
                                <select :class="{ 'is-invalid': errors.corrective_source_id, 'form-control': true}" v-model="action.corrective_source_id">
                                    <option :value="null">-- Select a Source --</option>
                                    <option v-for="(value, key) in sources" v-bind:value="key">
                                        {{ value }}
                                    </option>
                                </select>

                                <span v-if="errors.corrective_source_id" class="text-danger">
                                    <span v-for="error in errors.corrective_source_id">{{ error }}</span>
                                </span>
                            </div>
                        </div>

                        <action-assignees ref="otherAssignees" v-model="action" :errors="errors" :enableTextMuted="true"></action-assignees>

                        <div class="form-group row">
                            <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.location}">Location:</label>
                            <div class="col-sm-8">

                                <b-form-input type="text" v-model="action.location" :class="{ 'is-invalid': errors.location}" placeholder="Corrective Action Location"></b-form-input>

                                <span v-if="errors.location" class="text-danger">
                                    <span v-for="error in errors.location">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.due_date}">Due Date:</label>
                            <div class="col-sm-8">

                                <b-form-input type="date" v-model="action.due_date" :class="{ 'is-invalid': errors.due_date }" placeholder="Enter Date to be Completed By" />

                                <span v-if="errors.due_date" class="text-danger">
                                    <span v-for="error in errors.due_date">{{ error }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted">Is Subcontractor:</label>
                            <div class="col-sm-8">
                                <b-form-checkbox v-model="action.is_subcontractor" :value="1" :unchecked-value="0" plain />
                            </div>
                        </div>
                        <div v-if="action.is_subcontractor == 1">
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.subcontractor}">Subcontractor Name:</label>
                                <div class="col-sm-8">

                                    <b-form-input type="text" :class="{ 'is-invalid': errors.subcontractor}" v-model="action.subcontractor" placeholder="Enter Subcontractor" />

                                    <div class="text-info small">This is a free text field to enter the Subcontractor name. Any value is accepted.</div>

                                    <span v-if="errors.subcontractor" class="text-danger">
                                        <span v-for="error in errors.subcontractor">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.subcontractor_id}">Subcontractor Record:</label>
                                <div class="col-sm-8">

                                    <subcontractor-select :selectedValues="SubcontractorValues" @vselected="onSubSelectUpdate" :hasError="errors.subcontractor_id ? true : false"></subcontractor-select>

                                    <div class="text-info small">This field links to your list of subcontractors in MeritEHS. Use this to associate and view corrective actions on the Subcontractor record.</div>

                                    <span v-if="errors.subcontractor_id" class="text-danger">
                                        <span v-for="error in errors.subcontractor_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </b-card>

                    <b-card class="mb-4">
                        <div slot="header">Explain Corrective Action</div>
                        <textarea :class="{ 'is-invalid': errors.detail, 'form-control': true}" v-model="action.detail" placeholder="Enter Details" style="min-height: 100px;"></textarea>

                        <span v-if="errors.detail" class="text-danger">
                            <span v-for="error in errors.detail">{{ error }}</span>
                        </span>
                    </b-card>

                    <b-card class="mb-4">
                        <div slot="header">Completed Detail</div>
                        <textarea :class="{ 'is-invalid': errors.completed_detail, 'form-control': true}" v-model="action.completed_detail" placeholder="Enter Completed Details" style="min-height: 100px;"></textarea>

                        <span v-if="errors.completed_detail" class="text-danger">
                            <span v-for="error in errors.completed_detail">{{ error }}</span>
                        </span>
                    </b-card>

                    <b-card header="Files" class="mb-4">
                        <file-uploader ref="actionFileUploader" assetType="CorrectiveAction" :assetId="action.corrective_action_id" @fileUploaded="fileUploaded" />
                        <hr/>

                        <div class="mt-2">
                            <file-list :files="files" :editMode="true" :displayType="'list2.0'" />
                        </div>
                    </b-card>
                </div>
                <div class="col-xl-4 col-lg-12">
                    <b-card header="Created Details" class="mb-4">
                        <div class="row mb-3">
                            <div class="col-lg-3 col-12 mb-lg-0 mb-1 text-md-right text-muted">Created By:</div>
                            <div class="col-lg-8 col-12 mb-lg-0"><user-name :user="creator" /></div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-3 col-12 mb-lg-0 mb-1 text-md-right text-muted">Created At:</div>
                            <div class="col-lg-8 col-12 mb-lg-0">{{ action.created_at_formatted }}</div>
                        </div>
                    </b-card>
                </div>
            </div>

            <button type="button" class="btn btn-sm btn-success" v-on:click="saveAction(this)" :disabled="saving">
                Update Corrective Action
            </button>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                saving: false,
                loading: true,
                corrective_action_id: this.$route.params.id,
                action: {},
                files: [],
                errors: {},
                sources: [],
                statuses: [],
            }
        },

        computed: {
            creator() {
                return {
                    FirstName: this.action.creator_first_name,
                    LastName: this.action.creator_last_name,
                    deleted_at: this.action.creator_deleted_at,
                };
            },

            SubcontractorValues(){
                //check for null
                if(!this.action || !this.action.subcontractor_id || this.action.subcontractor_id == null)
                {
                    //Send it
                    return null;
                }

                //Send it
                return {subcontractor_id: this.action.subcontractor_id, subcontractor_name: this.action.subcontractor_name};
            },
        },

        methods: {

            saveAction() {
                //Show loading
                this.saving = true;

                //Set the Files So that We can Update Descriptiosn/Captions
                this.action.file_descriptions = this.files;

                //Send it
                this.$http.post('corrective-actions/edit/' + this.corrective_action_id, this.action)
                    .then(response => {
                        //Alert and Re-route
                        this.$toastr.success('Corrective Action Updated');

                        //Send
                        this.$router.push('/corrective-actions/view/' + this.corrective_action_id);
                    })
                    .catch(err => {
                        //Check for error
                        if(err.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = err.response.data
                        }
                    })
                    .then(() => {
                        //Show loading
                        this.saving = false;
                    });
            },

            getCorrectiveAction() {
                //Get the data
                this.$http
                    .get('corrective-actions/view/' + this.corrective_action_id, {edit: true})
                    .then(response => {
                        //Set all the data
                        this.action = response.data.action;
                        this.files = response.data.files;
                        this.statuses = response.data.statuses;
                        this.sources = response.data.actionSources;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            onSubSelectUpdate(sub) {
                //Check for null
                if(sub == null)
                {
                    //Clear the value
                    this.action.subcontractor_id = '';

                    //Stop Here
                    return;
                }

                //Send the value
                this.action.subcontractor_id = sub.subcontractor_id;
            },

            fileUploaded(dzFile, serverResponse){
                //Push it
                this.files.push(serverResponse);

                //Clear it
                this.$refs.actionFileUploader.clear(dzFile);

            }
        },

        mounted() {
            //Get the action
            this.getCorrectiveAction();
        }
    }
</script>
